import { useRouter } from 'next/router'

import { BRAND_COLORS_REFRESH } from 'lib/@getethos/experiments/constants'
import { useDecisionForFlag } from 'lib/FeaturesAndExperiments/getDecisionForFlag'

export const useBrandColorsTreatment = () => {
  const { CONTROL, TREATMENT_1 } = BRAND_COLORS_REFRESH.VARIATIONS
  const { asPath } = useRouter()

  const pathname = asPath?.split('?')[0]
  const isHomePage = pathname === '/'
  const isMetaLP = pathname === '/life/get-life-insurance/'

  const isBaselined = isHomePage || isMetaLP

  const { isEnabled, isLoading, variation } = useDecisionForFlag({
    name: BRAND_COLORS_REFRESH.EXPERIMENT_KEY,
    fallbackVariation: CONTROL,
  })

  const isTreatment1 = isEnabled && variation === TREATMENT_1

  return {
    isLoading,
    isTreatment: isBaselined || (isEnabled && isTreatment1),
  }
}
